import PropTypes from 'prop-types'
import React from 'react'
import {
  ButtonGroup
} from 'react-bootstrap'
import {
  MenuItem
} from 'components/Menu'
import Button from 'components/Button'
import KanBoIcon from 'components/KanBoIcon'
import Scrollbars from 'components/Scrollbars'
import {
  ModalMenu
} from 'components/Modal'
import HeaderButton from '../HeaderButton'
import classes from './View.module.scss'
import styled from 'styled-components'

const SubTitle = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: -6px;
  margin-bottom: 4px;
`

export class SidebarView extends React.Component {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    subtitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    buttons: PropTypes.array,
    inlineMenu: PropTypes.element,
    menu: PropTypes.array,
    onCloseClick: PropTypes.func,
    flex: PropTypes.bool,
    contentStyle: PropTypes.object,
    contentProps: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object,
  }

  static defaultProps = {
    flex: true
  }

  constructor (props) {
    super(props)

    this.handleMenuButtonRef = this.handleMenuButtonRef.bind(this)
    this.renderButton = this.renderButton.bind(this)
    this.renderMenu = this.renderMenu.bind(this)
  }

  handleMenuButtonRef (ref) {
    this.menuButtonRef = ref
  }

  renderButton (menuItem, index) {
    if (!menuItem) return null

    if (React.isValidElement(menuItem)) {
      return menuItem
    } else if (Array.isArray(menuItem)) {
      return (
        <ButtonGroup>
          {menuItem.map(this.renderButton)}
        </ButtonGroup>
      )
    } else {
      const { title, ...menuItemProps } = menuItem

      return (
        <Button
          {...menuItemProps}
          key={index}
        >
          {title}
        </Button>
      )
    }
  }

  renderMenu () {
    const { menu } = this.props

    return !!menu && (
      <ModalMenu>
        <HeaderButton
          icon={<KanBoIcon name='kanbo-16-options' />}
        />
        {menu.map((menuItem, index) => {
          const { title, ...menuItemProps } = menuItem

          return (
            <MenuItem
              {...menuItemProps}
              key={index}
            >
              {title}
            </MenuItem>
          )
        })}
      </ModalMenu>
    )
  }

  render () {
    const {
      children,
      title,
      subtitle,
      buttons,
      inlineMenu,
      onCloseClick,
      flex,
      contentStyle,
      contentProps,
      className,
      style,
    } = this.props

    let compClassName = classes.view
    if (flex) compClassName += ' ' + classes.flexView
    if (className) compClassName += ' ' + className

    return (
      <div className={compClassName} style={style}>
        <div className={classes.header}>
          <div className={classes.titleWrapper}>
            {subtitle &&
              <SubTitle>
                {subtitle}
              </SubTitle>
            }
            <h4 className={classes.title}>{title}</h4>
          </div>
          <div
            ref={this.handleMenuButtonRef}
            className={classes.headerButtonContainer}
          >
            {inlineMenu}
            {this.renderMenu()}
            {onCloseClick &&
              <HeaderButton
                icon={<KanBoIcon name='kanbo-16-remove' />}
                onClick={onCloseClick}
              />
            }
          </div>
        </div>
        {!!buttons &&
          <div className={classes.actions}>
            {buttons.map(this.renderButton)}
          </div>
        }
        <Scrollbars
          {...contentProps}
          className={classes.content}
          style={contentStyle}
        >
          {children}
        </Scrollbars>
      </div>
    )
  }
}

export default SidebarView
